export default __webpack_public_path__ + "static/media/consultaAgendamento.081070e5.svg";